import React, { MouseEventHandler, Ref } from 'react';
import theme from './Radio.module.scss';
import { classnames } from '@/utils/html';

export type RadioProps = React.InputHTMLAttributes<HTMLInputElement> & {
    labelClassName?: string;
    boxClassName?: string;
    contentClassName?: string;
    inline?: boolean;
    inputRef?: Ref<HTMLInputElement>;
    onMouseEnter?: MouseEventHandler<HTMLLabelElement>;
    onMouseLeave?: MouseEventHandler<HTMLLabelElement>;
    //TODO: fix for all events?
};

const preventSelection: MouseEventHandler<HTMLSpanElement> = (e) => {
    if (e.nativeEvent.detail > 1) {
        e.preventDefault();
    }
};

const Radio: React.FC<RadioProps> = React.forwardRef<HTMLLabelElement, RadioProps>(
    (
        { children, inline, labelClassName, boxClassName, contentClassName, inputRef, onMouseEnter, onMouseLeave, ...rest },
        ref
    ) => {
        return (
            <label
                ref={ref}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                className={classnames(theme.radio, { [theme.inline]: inline }, labelClassName)}>
                <input type="radio" ref={inputRef} {...rest} />
                <div className={boxClassName} />
                <span className={contentClassName} onMouseDown={preventSelection}>
                    {children}
                </span>
            </label>
        );
    }
);

export default Radio;